// Change Control types — mirror the backend's
// `ChangeControlRunResponseDto` from
// `packages/nest-backend/src/change_control/dto/change-control.dto.ts`.
// Defined locally to keep consistency with other Quality features that
// inline their types and avoid coupling to Orval's generated wrappers.

export type ChangeControlRunStatus =
  | 'queued'
  | 'processing'
  | 'completed'
  | 'partially_failed'
  | 'failed';

export type ChangeControlRunKind = 'bill_of_operations_release' | 'operation_release';

export interface ChangeControlRunResponse {
  change_control_run_id: string;
  partner_id: string;
  kind: ChangeControlRunKind;
  status: ChangeControlRunStatus;
  bill_of_operations_id: string | null;
  operation_id: string | null;
  target_version: number;
  total: number;
  completed: number;
  failed: number;
  initiated_by: string | null;
  initiated_at: string;
  completed_at: string | null;
  error_summary: string | null;
}

export interface ChangeControlRunItem {
  change_control_run_item_id: string;
  change_control_run_id: string;
  work_order_id: string;
  bill_of_operations_id: string;
  bill_of_operations_version: number;
  status: ChangeControlRunStatus;
  attempts: number;
  error: string | null;
  processed_at: string | null;
}

export interface StartBillOfOperationsReleaseInput {
  partner_id: string;
  bill_of_operations_id: string;
  work_order_ids: string[];
}

export interface StartOperationReleaseInput {
  partner_id: string;
  operation_id: string;
  target_version: number;
  work_order_ids: string[];
}

/** True when the run is in a terminal state (no further progress expected). */
export function isTerminalStatus(status: ChangeControlRunStatus): boolean {
  return status === 'completed' || status === 'partially_failed' || status === 'failed';
}
